export default __webpack_public_path__ + "static/media/hubspot.b6b35add.svg";